module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"page_title":"Kundendaten","save":"Speichern"},"en":{"page_title":"Customer Data","save":"Save"}}')
  delete Component.options._Ctor
}
